<template>
  <v-app id="app">
    <component :is="layout"></component>
  </v-app>
</template>

<script>
export default {
  name: "Main-App",
  computed: {
    layout() {
      return this.$route.meta.layout;
    }
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || "Argecam S.R.L.";
    }
  }
};
</script>
